<template>
  <div :class="classnames">
    <template v-if="this.$slots.default">
      <node-decorator :focusedTabId="focusedTabId">
        <node-filterer :nodes="this.$slots.default" :render="['tabs-content-item']" />
      </node-decorator>
    </template>
  </div>
</template>

<script>
  import NodeDecorator from '@/components/NodeDecorator'
  import NodeFilterer from '@/components/NodeFilterer'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'tabs-content'

  export default {
    name: 'TabsContent',
    components: {
      'node-decorator': NodeDecorator,
      'node-filterer': NodeFilterer
    },
    mixins: [ bem ],
    data: function () {
      const {
        focusedTabId
      } = this.$parent

      return {
        focusedTabId
      }
    },
    created: function () {
      this.namespace = namespace
    },
    mounted: function () {
      this.initialize()
    },
    methods: {
      handlesTabsFocus: function () {
        const self = this

        this.$parent.$on('focus', function (id) {
          self.setFocusedTabId(id)
        })
      },
      initialize: function () {
        this.handlesTabsFocus()
      },
      setFocusedTabId: function (id) {
        this.focusedTabId = id
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Tabs/TabsContent.vue